<template>
  <summary-table
    data-field="bet"
    format-type="number"
  />
</template>

<script>
import SummaryTable from '@core/components/summary/SummaryTable.vue'

export default {
  name: 'TotalBet',
  components: {
    SummaryTable,
  },
}
</script>
